export type ColumnsTypes = 'text' | 'directional' | 'number' | 'status';

export type StatusTypes<T> = 'Success' | 'Failed' | T;

export const statusTypes: StatusTypes<string>[] = ['Success', 'Failed'];

export type TableData = {
  value: string | number;
  tooltip?: string;
  logo?: string | null;
};

export type TableRow<T extends string = string> = Record<T, TableData>;

export type TableColumns = {
  id: string;
  title: string;
  type: ColumnsTypes;
  tooltip?: string;
  sticky?: boolean | null;
};

export type TableV2Payload<T extends string = string> = {
  columnsMeta: TableColumns[];
  data: TableRow<T>[];
  stickyHeader?: boolean | null;
};
